var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiotailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40713 29.8008C5.63193 29.8008 5.77353 29.5584 5.66313 29.3624L4.98153 28.1568C2.46233 23.2912 4.44713 15.9616 9.41433 13.4592C9.71513 13.308 10.6111 12.94 10.4095 13.6064C10.3775 13.7136 9.15353 14.784 8.93993 15.0296C5.08553 19.4576 6.50713 26.8112 11.9759 29.1296C18.4639 31.88 24.7671 25.9472 23.5839 19.284C23.1495 16.8384 21.6919 14.6904 19.6287 13.3472C19.4927 13.2592 19.4583 13.076 19.5471 12.9408C20.0751 12.1368 20.5295 11.3424 20.8047 10.3968C22.3943 4.93761 18.1055 0.00961392 12.5759 0.187214L1.44473 0.190414C0.795931 0.190414 0.269531 0.716814 0.269531 1.36561V28.6264C0.269531 29.2752 0.795931 29.8016 1.44473 29.8016H5.40633L5.40713 29.8008Z",
    fill: "#1E562C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiotailLogo);
export default __webpack_public_path__ + "static/media/biotail_logo.504325862a9c9d1452da157c7d3c47e1.svg";
export { ForwardRef as ReactComponent };